module.exports = "/_next/static/images/DelightYourCustomers-864207686f9b3bb99d7f84f25bb76609.webp";